import { jsx as _jsx } from "react/jsx-runtime";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ArrowButton } from "./ScrollIndicatorArrow.styles";
const SCROLL_BOTTOM_THRESHOLD = 40;
const POLL_INTERVAL_MS = 500;
function checkShouldShow() {
    var _a;
    const scrollEl = (_a = document.scrollingElement) !== null && _a !== void 0 ? _a : document.documentElement;
    const scrollHeight = scrollEl.scrollHeight;
    const viewportHeight = Math.max(scrollEl.clientHeight, window.innerHeight);
    const maxScroll = scrollHeight - viewportHeight;
    if (maxScroll <= 10)
        return false;
    return maxScroll - Math.ceil(window.scrollY) >= SCROLL_BOTTOM_THRESHOLD;
}
export const ScrollIndicatorArrow = () => {
    const { t } = useTranslation(["patients"]);
    const [visible, setVisible] = React.useState(false);
    const [tapped, setTapped] = React.useState(false);
    const tapTimerRef = React.useRef(null);
    React.useEffect(() => {
        var _a;
        const update = () => setVisible(checkShouldShow());
        update();
        window.addEventListener("scroll", update, { passive: true });
        window.addEventListener("resize", update, { passive: true });
        (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener("resize", update);
        const intervalId = setInterval(update, POLL_INTERVAL_MS);
        return () => {
            var _a;
            window.removeEventListener("scroll", update);
            window.removeEventListener("resize", update);
            (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener("resize", update);
            clearInterval(intervalId);
            if (tapTimerRef.current)
                clearTimeout(tapTimerRef.current);
        };
    }, []);
    const handleClick = () => {
        var _a;
        if (tapTimerRef.current)
            clearTimeout(tapTimerRef.current);
        setTapped(true);
        tapTimerRef.current = setTimeout(() => setTapped(false), 200);
        const scrollEl = (_a = document.scrollingElement) !== null && _a !== void 0 ? _a : document.documentElement;
        window.scrollTo({ top: scrollEl.scrollHeight, behavior: "smooth" });
    };
    return (_jsx(ArrowButton, { "$visible": visible, "$tapped": tapped, onClick: handleClick, "aria-label": t("Scroll to bottom"), children: _jsx(ArrowDownward, {}) }));
};
